/**
 * Landing-page section navigation.
 *
 * The site is routed on the pathname, so a bare `#workshops` anchor only
 * resolves while the landing page is mounted. Clicked from a policy page or a
 * workshop page it did nothing at all, which is what the gateway's whitelisting
 * review flagged in the footer. These helpers route home first, then scroll
 * once the section has actually rendered.
 */

/** How long to keep looking for the section after routing home. */
const RETRY_MS = 50;
const MAX_TRIES = 20; // ~1s, comfortably longer than the landing page takes.

/** Strip `/`, `#` and any query so callers can pass an href or a bare id. */
const toId = (hash) => String(hash).replace(/^.*#/, '');

/**
 * Scroll to a section, waiting for it to mount if the landing page is still
 * rendering. The sticky header is cleared by `scroll-padding-top` on `html`.
 */
export function scrollToSection(hash, triesLeft = MAX_TRIES) {
  if (typeof document === 'undefined') return;

  const target = document.getElementById(toId(hash));
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  if (triesLeft > 0) {
    setTimeout(() => scrollToSection(hash, triesLeft - 1), RETRY_MS);
  }
}

/**
 * Handle a click on a section link from anywhere on the site: go home first if
 * we are not already there, then scroll.
 */
export function goToSection(hash, route, navigate) {
  if (route !== '/') navigate('/');
  scrollToSection(hash);
}
